import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "slices/app/store/store";
import PermissionsProvider from "Layout/Permissions/PermissionsProvider";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import CountData from "modules/dashboard/components/CountData";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <PermissionsProvider>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <App />
            <CountData />
          </BrowserRouter>
        </PermissionsProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
